"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _Field = _interopRequireDefault(require("../Field/Field"));

var _icons = require("../../assets/icons");

var _NumberField = require("./NumberField.styles");

var _elements = require("../../styles/elements");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var isNotNumber = function isNotNumber(val) {
  return Number.isNaN(Number.parseFloat(val));
};

var isExists = function isExists(val) {
  if (val !== 0 && !val) {
    return false;
  }

  return true;
};

var NumberField = function NumberField(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange,
      onBlur = _ref.onBlur,
      onFocus = _ref.onFocus,
      min = _ref.min,
      max = _ref.max,
      hasMaxHint = _ref.hasMaxHint,
      step = _ref.step,
      className = _ref.className,
      name = _ref.name,
      label = _ref.label,
      validateStatus = _ref.validateStatus,
      help = _ref.help,
      tagPosition = _ref.tagPosition,
      tagContent = _ref.tagContent,
      disabled = _ref.disabled,
      required = _ref.required,
      otherProps = (0, _objectWithoutProperties2["default"])(_ref, ["value", "onChange", "onBlur", "onFocus", "min", "max", "hasMaxHint", "step", "className", "name", "label", "validateStatus", "help", "tagPosition", "tagContent", "disabled", "required"]);
  var inputRef = (0, _react.useRef)(null);
  var handleChangeStep = (0, _react.useCallback)(function (e, isDown) {
    var stepAmount = isNotNumber(step) ? 1 : step; // Keep focus on input

    var inputElement = inputRef.current;
    inputElement.focus();
    e.target.blur();
    var newValue = parseFloat(value);

    if (isDown && (isNotNumber(min) || value > min)) {
      // Step down: value is bigger than min
      newValue -= stepAmount;
    } else if (!isDown && (isNotNumber(max) || value < max)) {
      // Step up: value is smaller than max or max is not a number
      newValue += stepAmount;
    }

    if (newValue > max) {
      newValue = max;
    } else if (newValue < min) {
      newValue = min;
    }

    onChange({
      target: Object.assign(inputElement, {
        value: parseFloat(newValue.toFixed(10))
      })
    });
  }, [max, min, onChange, step, value]);
  var handleChangeStepIsDown = (0, _react.useCallback)(function (e) {
    return handleChangeStep(e, true);
  }, [handleChangeStep]);
  var innerButton = (0, _react.useMemo)(function () {
    return (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [hasMaxHint && isExists(max) && (0, _jsxRuntime.jsx)("span", {
        className: "grui mr-10",
        css: [_elements.text.styles.textMediumDark, _NumberField.styles.maxHint, process.env.NODE_ENV === "production" ? "" : ";label:innerButton;"],
        children: "/ ".concat(max)
      }), (0, _jsxRuntime.jsxs)("div", {
        css: _NumberField.styles.controls,
        children: [(0, _jsxRuntime.jsx)("button", {
          className: "grui",
          css: _elements.button.styles.preflight,
          type: "button",
          onClick: handleChangeStep,
          children: (0, _jsxRuntime.jsx)(_icons.ArrowDown, {})
        }), (0, _jsxRuntime.jsx)("button", {
          className: "grui",
          css: _elements.button.styles.preflight,
          type: "button",
          onClick: handleChangeStepIsDown,
          children: (0, _jsxRuntime.jsx)(_icons.ArrowDown, {})
        })]
      })]
    });
  }, [handleChangeStep, handleChangeStepIsDown, hasMaxHint, max]);
  return (0, _jsxRuntime.jsx)(_Field["default"], _objectSpread({
    htmlType: "number",
    value: value,
    onChange: onChange,
    onBlur: onBlur,
    onFocus: onFocus,
    min: min,
    max: max,
    step: step,
    css: _NumberField.styles.base,
    className: className,
    innerButton: innerButton,
    name: name,
    label: label,
    validateStatus: validateStatus,
    help: help,
    ref: inputRef,
    tagPosition: tagPosition,
    tagContent: tagContent,
    disabled: disabled,
    required: required
  }, otherProps));
};

NumberField.propTypes = {
  value: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string]),
  onChange: _propTypes.func,
  onBlur: _propTypes.func,
  onFocus: _propTypes.func,
  min: _propTypes.number,
  max: _propTypes.number,

  /**
   * Has maximun hint left to up/down icon
   */
  hasMaxHint: _propTypes.bool,
  step: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string]),
  className: _propTypes.string,
  name: _propTypes.string,
  label: _propTypes.string,
  validateStatus: (0, _propTypes.oneOf)(['success', 'error']),
  help: _propTypes.string,

  /**
   * Preset or suffix tag
   */
  tagPosition: (0, _propTypes.oneOf)(['left', 'right']),
  tagContent: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.node]),
  disabled: _propTypes.bool,
  required: _propTypes.bool
};
NumberField.defaultProps = {
  value: undefined,
  onChange: function onChange() {},
  onBlur: function onBlur() {},
  onFocus: function onFocus() {},
  min: undefined,
  max: undefined,
  hasMaxHint: false,
  step: 1,
  className: undefined,
  name: '',
  label: '',
  validateStatus: undefined,
  help: undefined,
  tagPosition: undefined,
  tagContent: undefined,
  disabled: undefined,
  required: false
};
var _default = NumberField;
exports["default"] = _default;
//# sourceMappingURL=NumberField.js.map